import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators.js';

/**
 * Header Navigation Component
 * Top navigation bar with logo and CTA button
 * Follows constitution.md: Light DOM, Tailwind-first, responsive design
 */
@customElement('header-nav')
export class HeaderNav extends LitElement {
  // Disable Shadow DOM to use global Tailwind styles
  protected createRenderRoot() {
    return this;
  }

  private _handleCTAClick() {
    // Check if we're on the landing page
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      // On landing page - smooth scroll to contact section
      contactSection.scrollIntoView({behavior: 'smooth', block: 'start'});
    } else {
      // On other pages - navigate to landing page with hash
      window.location.href = '/#contact-section';
    }
  }

  render() {
    return html`
      <header
        class="fixed top-0 left-0 right-0 z-50 bg-surface-base px-4 lg:px-16 py-4"
      >
        <div class="container mx-auto">
          <div class="flex items-center justify-between">
            <!-- Logo - Clickable to return home -->
            <a
              href="/"
              class="flex items-center gap-2 hover:opacity-80 transition-opacity duration-200"
            >
              <span class="text-text-primary font-mono text-sm md:text-base"
                >&gt;&gt;</span
              >
              <span
                class="text-text-primary font-sans font-medium text-sm md:text-base"
                >Forward Compute</span
              >
            </a>

            <!-- CTA Button -->
            <button
              @click="${this._handleCTAClick}"
              class="px-5 py-3 bg-surface-elevated text-text-primary text-sm font-sans hover:bg-surface-overlay transition-colors duration-200"
            >
              Talk to an expert
            </button>
          </div>
        </div>
      </header>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'header-nav': HeaderNav;
  }
}
